import Reflux from 'reflux';
class SlideActionsFactory{
	constructor(){
		this.actions = {};
	}
	get(CarouselId){
		const key = `carousel-${CarouselId}`;
		if(!this.actions[key]){
			this.actions[key] = Reflux.createActions([
			  'afterChange',
			  'beforeChange',
			  'toggleNotes',
			  'toggleLinks'
			]);
		}
		return this.actions[key];

	}
}

export default new SlideActionsFactory();



// WEBPACK FOOTER //
// ./src/app/carousel/slide-actions-factory.js